import { useContext } from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTags from '@/components/MetaTags';
import PageTitle from '@/components/PageTitle';
import { AboutVideoLarge } from '@/components/blocks/AboutVideo';
import CountsAbout from '@/components/blocks/CountsAbout';
import AboutPrincipes from '@/components/blocks/AboutPrincipes';
// import TeamSlider from '@/components/blocks/TeamSlider';
import useMetaTags from '@/hooks/useMetaTags';
import { useTheme } from '@forma/forma-ui-theme';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';

import mockApi from '@/api/mockApi';

export const getServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const mainData = await mockApi.getMainData(params.locale);
  const pageData = await mockApi.getPageData(params.locale, 'about');
  const teamData = await mockApi.getPageData(params.locale, 'team');
  const headersParse = await getHeadersFromServer(req);
  return {
    props: {
      initialState: {
        main: mainData
      },
      about: pageData,
      team: teamData,
      headersParse,
      ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
    },
  };
};

const ContentPage = ({ about }) => {
  const { t } = useTranslation();
  const { video, counts, principes } = about;
  // const [formStatus, setFormStatus] = useState(false);

  const metaData = {
    title: t('meta_titles.about'),
    description: t('meta_descriptions.about'),
    keywords: t('main_keywords'),
  };
  const { lang } = useTheme();
  useMetaTags({ lang, ...metaData });

  // const handleSubmit = async (values) => {
  //   const result = await requests.sendResume(values, lang);

  //   if (result) setFormStatus('success');
  //   else setFormStatus('error');
  // };

  return (
    <div>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>

      <div className="container">
        <PageTitle
          breadcrumbs={[{ name: t('about_us') }]}
          title={t('about_us')}
        />

        <div style={{
          maxWidth: '800px',
          fontSize: '1.15rem',
          fontWeight: 600,
          margin: '-30px auto 40px',
          textAlign: 'center',
          fontFamily: 'var(--headings-font)'
        }}>
          {t('about_page_title')}
        </div>

        <AboutVideoLarge video={video} />
        <CountsAbout items={counts} />
        <AboutPrincipes items={principes} />
        {/* <TeamSlider
          items={team}
          onSubmit={handleSubmit}
          isSendSuccess={formStatus === 'success'}
          isSendError={formStatus === 'error'}
        />*/}
      </div>
    </div>
  );
};

export default ContentPage;
